'use strict';

var _setup = require('./setup');

// urgent fix to hide prices of all grills on the US site and mark one grill as "Sold Out"
_setup.s.$doc.ready(function () {
  if (window.location.hostname !== 'nexgrill.com') return; // just in case this gets pushed to other envs

  var hidePriceTags = _setup.s.$body.hasClass('is-collection-grills') || _setup.s.$body.hasClass('template-index') || _setup.s.$body.hasClass('template-article');
  var grillSectionPriceTags = $('#shopify-section-products-grills-feature').find('.nx-productlist--price');

  if (grillSectionPriceTags.length) {
    grillSectionPriceTags.remove();
  }

  var $priceTags = void 0;

  if (hidePriceTags) {
    $priceTags = $('.nx-productlist--price');
    $priceTags.remove();
  }

  if (_setup.s.$body.hasClass('nx-productpage-grills')) {
    var $heroDetails = $('#nx-producthero-details');
    var $productSKU = $('.nx-producthero--sku');
    var $heroPriceTag = $('.nx-producthero--price');
    var $productPromos = $('.nx-productpromo');

    // if it's the "fortress" grill, display it as "Sold Out"
    if ($productSKU.text() === '#820-0062') {
      $heroDetails.append('\n        <a class="nx-btn nx-btn--primary" href="#0">\n          Coming Soon\n        </a>\n      ');
    }

    // add a little disclaimer under the purchase button
    $heroDetails.append('\n      <div class="nx-producthero--disclaimer" style="margin-top: .5rem;">\n        <span style="font-size: 80%;">Pricing subject to retailer.</span>\n      </div>\n    ');

    $heroPriceTag.remove();

    // remove prices from product promo sections if the promo section contains grills, not accessories
    $productPromos.each(function () {
      var $t = $(this);
      var $headingToCheck = $t.find('.nx-heading--lg');

      if ($headingToCheck.text().toLowerCase().indexOf('grills') > -1) {
        $t.find('.nx-productlist--price').remove();
      }
    });
  }
});


//////////////////
// WEBPACK FOOTER
// ./_js/temp.js
// module id = 22
// module chunks = 0